__turbopack_context__.v({
  "blocksBackgroundColor": "TimePicker-module-scss-module__7dOrHa__blocksBackgroundColor",
  "blocksFontColor": "TimePicker-module-scss-module__7dOrHa__blocksFontColor",
  "container": "TimePicker-module-scss-module__7dOrHa__container",
  "secondaryNavBackgroundColor": "TimePicker-module-scss-module__7dOrHa__secondaryNavBackgroundColor",
  "themeBackgroundColor": "TimePicker-module-scss-module__7dOrHa__themeBackgroundColor",
  "themeFontColor": "TimePicker-module-scss-module__7dOrHa__themeFontColor",
});
